import styled from "styled-components";
import { Theme } from "@tvg/design-system";

export const PicksSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PicksSelectorColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 44px;
`;

export const PicksSelectorRunnerInfoColumnContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 0;
`;

export const PicksSelectorHeaderEntryContainer = styled.div`
  width: 44px;
  display: flex;
  flex: 0 0 44px;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid
    ${(props: { isSelected: boolean; theme: Theme }) =>
      props.theme.colors.blue["200"]};
  ${(props: { isSelected: boolean; theme: Theme }) =>
    props.isSelected && `background: ${props.theme.colors.blue["100"]};`}
`;

export const PicksSelectorEntryContainer = styled.div`
  width: 44px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid
    ${(props: { theme: Theme }) => props.theme.colors.blue["100"]};
`;

export const PicksSelectorSaddleContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PicksSelectorEntryLabelContainer = styled.div`
  width: 44px;
  height: 33px;
  padding-top: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const PickSelectorHeader = styled.div`
  flex: 0 0 85px;
  min-height: 85px;
  display: flex;
  background: ${(props: { theme: Theme }) =>
    props.theme.colors.blue_accent["000"]};
  box-shadow: inset 0 -2px 0 ${(props: { theme: Theme }) => props.theme.colors.blue["200"]};
`;

export const PickSelectorMainContainer = styled.div`
  flex: 1;
  display: flex;
`;

export const PicksSelectorRaceHeaderContainer = styled.div`
  max-height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
